import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isContentCountry } from 'globalConfigApp'
import { companyConfig } from 'globalConfigApp'

import style from './styles'

export default class RgpdCoponent extends Component {
  static propTypes = {
    handleValidRgpd: PropTypes.func.isRequired,
    checkedRgpd: PropTypes.bool.isRequired
  }

  render() {
    const { checkedRgpd} = this.props
    return (
      <div className="esp">
        {
          isContentCountry(['es']) &&
          (
            <div>
              <p>
                Conforme al RGPD y la LOPDGDD, {companyConfig.name} ESPAÑA tratará los datos facilitados, con la finalidad de contestar las solicitudes de información recibidas a través del presente formulario.
                Podrá ejercer, si lo desea, los derechos de acceso, rectificación, supresión, y demás reconocidos en la normativa mencionada.
              Para obtener más información acerca de cómo estamos tratando sus datos, acceda a nuestra política de privacidad.</p>
              <p>
                <input
                  type="checkbox"
                  name="rgdp"
                  checked={checkedRgpd}
                  onClick={(e) => this.props.handleValidRgpd(e.target.checked)}
                />
                <strong> ENTIENDO Y ACEPTO </strong> el tratamiento de mis datos tal y como se describe  anteriormente y se explica con mayor detalle en la <a className="tandc" href="#">Política de Privacidad</a>.
              (Su negativa a facilitarnos la autorización implicará la imposibilidad de tratar sus datos con la finalidad indicada).</p>
            </div>
          )
        }
        <style jsx>{style}</style>
      </div>
    )
  }
}
